import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2175ea1c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2175ea1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175ea1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2175ea1c')) {
      api.createRecord('2175ea1c', component.options)
    } else {
      api.reload('2175ea1c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2175ea1c&scoped=true&", function () {
      api.rerender('2175ea1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Bq2AowewX46V/JS/comp/DocBox.vue"
export default component.exports